<script>
import Loader from "@/components/Loader.vue";

import TokenTransactionsFilterPanel from "@/components/tokenTransactions/TokenTransactionsFilterPanel.vue";
import DownloadConfirmationsPanel
    from "@/components/tokenTransactions/DownloadConfirmationsPanel.vue";
import {useTokenTransactionDownloads} from "@/composables/useTokenTransactionDownloads.js";
import TokenTransactionsTable from "@/components/tokenTransactions/TokenTransactionsTable.vue";
import UserCompanies from "@/components/users/UserCompanies.vue";

export default {
    components: {
        UserCompanies,
        TokenTransactionsTable,
        DownloadConfirmationsPanel, TokenTransactionsFilterPanel, Loader },


    data() {
        return {
            error: '',
            loading: true,
            downloading: false,
            transactions: [],
            meta: { current_page: 1, total: 0, per_page: 0 },
            controller: { data: null, companies: null },
            companies: [],
            loadingCompanies: true,
            companyId: null,
            filters: {},
            selectionMode: false,
            selectedIds: [],
            perPage: parseInt(localStorage.getItem('perPage_tokenTransactions') || '10'),
        };
    },
    methods: {
        onChangeSelectionMode() {
            this.selectionMode = !this.selectionMode;
            if (!this.selectionMode) {
                this.selectedIds = [];
            }
        },
        onFiltersChange(filters) {
            this.filters = filters;
            this.meta.current_page = 1;
            this.loadData();
        },
        onToggleRow(transaction) {
            const idx = this.selectedIds.indexOf(transaction.id);
            if (idx !== -1) {
                this.selectedIds.splice(idx, 1);
            } else {
                this.selectedIds.push(transaction.id);
            }
        },
        loadData() {
            if (this.controller.data) this.controller.data.abort();
            this.controller.data = new AbortController();
            this.loading = true;
            window.scrollTo({ top: 0 });
            axios.get('/token-transactions', {
                signal: this.controller.data.signal,
                params: {
                    company_id: this.companyId,
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    filters: this.filters,
                },
            }).then(response => {
                this.transactions = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).finally(() => {
                this.loading = false;
            });
        },
        onPageChange(page) {
            this.controller.data.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onPerPageChange(val) {
            this.perPage = val;
            this.meta.current_page = 1;
            this.loadData();
        },
        loadCompanies() {
            if (this.controller.companies) this.controller.companies.abort();
            this.controller.companies = new AbortController();
            this.loadingCompanies = true;
            axios.get('/companies', {
                signal: this.controller.companies.signal,
            }).then(response => {
                this.companies = response.data.data;
            }).catch(() => {
            }).finally(() => {
                this.loadingCompanies = false;
            });
        },
        download() {
            this.downloading = true;
            let params = {
                company_id: this.companyId,
                filters: this.filters,
                xlsx: 1
            }
            axios({
                url: '/token-transactions',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'transactions.xlsx');
            }).finally(() => {
                this.downloading = false;
            });
        }
    },
    mounted() {
        this.loadData();
        if (this.$auth.isAdmin()) this.loadCompanies();
    },
    beforeUnmount() {
        this.controller.companies && this.controller.companies.abort();
        this.controller.data && this.controller.data.abort();
    },
    computed: {
        canDownloadConfirmation() {
            if (this.$auth.isEmployee() && import.meta.env.VITE_ENABLE_TRANSACTION_CONFIRMATION_CLIENT !== 'true') {
                return false;
            }
            return true;
        }
    }
};
</script>
<template>
    <section class="token-transfers-index">

        <div class="my-4">
            <TokenTransactionsFilterPanel @change="onFiltersChange" :companies="companies">
                <template #buttons>
                    <b-button v-if="$auth.isAdmin()" :loading="downloading"  type="is-link" icon-left="download" @click="download">
                        .xlsx
                    </b-button>
                </template>
            </TokenTransactionsFilterPanel>
        </div>

        <DownloadConfirmationsPanel
            v-if="canDownloadConfirmation"
            @onChangeSelectionMode="onChangeSelectionMode"
            :selectionMode="selectionMode"
            :company-id="companyId"
            :filters="filters"
            :total="meta.total"
            :selectedIds="selectedIds"/>

        <TokenTransactionsTable
            :data="transactions"
            :selectionMode="selectionMode"
            :meta="meta"
            :loading="loading"
            :selectedIds="selectedIds"
            :detailsView="true"
            storage-key="perPage_tokenTransactions"
            @onToggleRow="onToggleRow"
            @onPageChange="onPageChange"
            @onPerPageChange="onPerPageChange"
        />

        <loader :loading="loading"/>

    </section>
</template>
